import en_about from './about_en.js';
import sustainability_en from './sustainability_en.js';
import server_en from './server_en.js';
import solution_en from './solution_en.js';

export default {
  nav: {
    home: 'Home',
    solution: 'Solutions & Products',
    store: 'Energy Storage',
    datacenter: 'data Center',
    charging: 'Charging Pile / Charging Terminal',
    photovoltaic: 'photovoltaic',
    windpower: 'Wind Power',
    service: 'Service & Support',
    sustainability: 'Sustainability',
    about: 'About Us',
  },
  homepage: {
    text0: 'Connect Green Mission, Build Sustainable Value Together',
    text1:
      'Focus on the full scenarios of power generation, transmission, distribution and consumption in the energy sector.We provide energy storage management systems, PCS converters, integrated energy storage cabinets and industrial power supply products.For ecological partners, we deliver products and solutions covering power conversion, power quality control, energy management and power control.',
    entype: {
      n0: 'Solar',
      n1: 'Wind',
      n2: 'Energy Storage',
      n3: 'Power',
      n4: 'Data Center',
    },
    enimg: require('@/assets/images/icon00.gif'),
    sztext: require('@/assets/images/icon3.gif'),
    brand: require('@/assets/images/carousel10.gif'),
    advantages: {
      Icon0: {
        title: 'Industry-leading Time-honored Brand',
        concent:
          'Equipped with professional and advanced production facilities, we feature rigorous quality control and a professional workforce.',
      },
      Icon1: {
        title: 'Stable Production',
        concent:
          'Excellent supply chain collaborative management and advanced production technology ensure stable productivity.',
      },
      Icon2: {
        title: 'Advanced Technology',
        concent:
          'An innovative technology enterprise with a professional R&D team and rich industry experience.',
      },
      Icon3: {
        title: 'After-sales Service Advantages',
        concent:
          'We provide high-quality products and satisfactory services, and follow the modern quality management system.',
      },
    },
  },
  footer: {
    name: 'Shenzhen Huanneng Shuhang Co., Ltd.',
    email: 'Email: hailong@gedntech.com',
    hotline: 'Hotline: 400 - 852 - 976',
    landline: 'Landline: 0769 - 82867936',
    reserved:
      'Copyright © 2026 Shenzhen Huaneng Digital Navigation Co., Ltd. All Rights Reserved',

    about: 'about Us',
    aboutus: 'Company Profile',
    honors: 'Honors & Certifications',

    datacenter: 'Data Center',
    project: 'Project Overview',
    planning: 'Planning & Layout',
    visit: 'Data Center Visit',

    contact: 'Contact Us',
    contactus: 'Contact Information',
  },
  logo: require('@/assets/images/logo1.jpg'),
  language: 'English',
  title: 'Welcome to Our Company Website',
  button: {
    submit: 'Submit',
  },
  ...en_about,
  ...sustainability_en,
  ...server_en,
  ...solution_en,
};
